//------------------------------------------------------------------------
// Import Main Styles for Webpack
//------------------------------------------------------------------------
require('../sass/main.scss');

// -----------------------------------------------------------------------------
// Intersection Observer Polyfill
// -----------------------------------------------------------------------------
import 'intersection-observer';


// Lodash
const throttle = require('lodash/throttle');

// -----------------------------------------------------------------------------
// Check if is a touch device
// -----------------------------------------------------------------------------
function isTouchDevice() {
  return 'ontouchstart' in document.documentElement;
}

if (isTouchDevice()) {
  document.body.classList.add('touch');
} else {
  document.body.classList.add('no-touch');
}

// -----------------------------------------------------------------------------
// Favicon Switcher
// -----------------------------------------------------------------------------
import './modules/favicon';

// -----------------------------------------------------------------------------
// Page content Lazy Loading & Animations
// -----------------------------------------------------------------------------
import LazyLoad from 'vanilla-lazyload';

var pageLazyLoad = new LazyLoad({
  elements_selector: ".lazy img",
  threshold: 50,
  callback_loaded: (el) => {
    el.parentElement.classList.add('loaded');
  }
});
import animateContent from './modules/animate-content.js';


// -----------------------------------------------------------------------------
// Project Content Lazy Loading & Animation
// -----------------------------------------------------------------------------
import projectLazyLoad from './modules/project-lazyload.js';
import videoLazyLoad from './modules/video-lazyload.js';
import animateProjectContent from './modules/animate-project-content.js';
import inviewVideos from './modules/inview-videos.js';


// -----------------------------------------------------------------------------
// Articles Infinite Scroll
// -----------------------------------------------------------------------------
import InfiniteScroll from 'infinite-scroll';
function revealArticle() {
  const infiniteItems = document.querySelectorAll('.infinite-item');
  infiniteItems.forEach(item => {
    item.classList.add('visible');
  });
}

function infiniteArticles() {
  const postListing = document.querySelector('.infinite-container');
  if (postListing) {
    const infScroll = new InfiniteScroll( '.infinite-container', {
      path: '.infinite-more-link',
      append: '.infinite-item',
      history: false,
      hideNav: '.more-articles',
      status: '.scroller-status'
    });
    infScroll.on( 'append', function( response, path, items ) {
      items.forEach(item => {
        item.classList.add('visible');
        item.addEventListener('click', clickableTile);
      });
    });
  }
}

// -----------------------------------------------------------------------------
// Load Custom Modules
// -----------------------------------------------------------------------------
import stickyNav from './modules/sticky-nav';
import inviewFooter from './modules/footer';
// import logoScroll from './modules/logo-scroll';
import disableScroll  from './modules/disable-scroll';    
import getScrollbarWidth from './modules/get-scrollbar-width';
import toggleScroll from './modules/toggle-scroll';
import trackPageView from './modules/ga-tracking.js';
import safeMailto from './modules/safer-mailto.js';
import './modules/menu-toggle.js'; 

import animatedIcons from './modules/animated-icons.js';
import headerVideo from './modules/header-video.js';
// var slidingFooter = require('./modules/footer.js');
// var slidingPanels = require('./modules/sliding-panels.js');

import teamMembers from './modules/team-listing.js';
import animateServices from './modules/services.js';
// var revealArticle = require('./modules/reveal-articles.js');
// var infiniteArticles = require('./modules/infinite-articles.js');

import collapsibles from './modules/collapsible.js';

import matchHeight from './modules/match-height.js';
import debounce from './modules/debounce.js';
window.addEventListener('resize', debounce(matchHeight));

// -----------------------------------------------------------------------------
// Global Variables
// -----------------------------------------------------------------------------
const pjaxContainer = document.querySelector('#pjax-container');
const pjaxMask = document.querySelector('.pjax-mask');
const pjaxLoader = document.querySelector('#pjax-loader');

// -----------------------------------------------------------------------------
// Update Ref
// -----------------------------------------------------------------------------
let refURL = '';
let isPanel = false;
window.updateRef = function(newRef) {
  refURL = newRef;
};

// -----------------------------------------------------------------------------
// Menu Parent Item
// -----------------------------------------------------------------------------
window.menuParentItem = function(parentClass) {
  // alert(parentClass);
  const parentItem = document.querySelector(parentClass);
  parentItem.classList.add('current-menu-item');
};

// -----------------------------------------------------------------------------
// Hoverable Tiles
// -----------------------------------------------------------------------------
const siteWrapper = document.querySelector('#site-wrapper');

siteWrapper.addEventListener('mouseenter', (e) => {
  if(e.target && e.target.matches('.clickable')) {
    e.target.classList.add('hover');
  }
});

siteWrapper.addEventListener('mouseleave', (e) => {
  if(e.target && e.target.matches('.clickable')) {
    e.target.classList.remove('hover');
  }
});

// -----------------------------------------------------------------------------
// Load Project Ajax
// -----------------------------------------------------------------------------

function initProject() {
  projectLazyLoad();
  videoLazyLoad();
  animateProjectContent();
  // devicesCarousel();
  inviewVideos();
}



function loadProject(projectURL,projectBtn,projectTitle,projectRef) {

  const request = new XMLHttpRequest();
  request.open('GET', projectURL, true);

  const panel = document.querySelector('.side-panel');
  const projectContainer = document.querySelector('#side-panel-content');

  request.onload = function() {
    panel.classList.add('visible');
    toggleScroll('disable');
    // panel.style.paddingRight = `${getScrollbarWidth()}px`;
    if (request.status >= 200 && request.status < 400) {

      const resp = request.responseText;
      const parser = new DOMParser();
      const html = parser.parseFromString(resp,"text/html");
      const projectContent = html.querySelector('#project-content');
      projectContainer.appendChild(projectContent);
      isPanel = true;
      updateRef(projectRef);
      history.pushState(null,projectTitle,projectURL);
      trackPageView(projectURL);
      initProject();
      setTimeout( ()=> {
        projectBtn.classList.remove('loading');
        projectContainer.classList.add('loaded');
      },250);

    } else { 
      // We reached our target server, but it returned an error
      console.log(request.error);
    }
  };
  request.send();
}

function loadNextProject(projectURL,projectTitle,direction) {
  const request = new XMLHttpRequest();
  request.open('GET', projectURL, true);

  const projectContainer = document.querySelector('#side-panel-content');

  pjaxMask.classList.remove('visible','hide','reverse');
  if(direction === 'reverse') {
    pjaxMask.classList.add('reverse');
  }
  pjaxMask.classList.add('show');
  setTimeout( () => {
    pjaxLoader.style.visibility = 'visible';
    pjaxLoader.classList.add('visible');
    // pjaxContainer.classList.add('hidden');
  }, 350);

  request.onload = function() {
    if (request.status >= 200 && request.status < 400) {
      const resp = request.responseText;
      const parser = new DOMParser();
      const html = parser.parseFromString(resp,"text/html");
      const projectContent = html.querySelector('#project-content');
      projectContainer.innerHTML = "";

      pjaxMask.classList.add('visible');
      pjaxMask.classList.remove('show');

      setTimeout(function() {

        projectContainer.appendChild(projectContent);
        history.pushState(null,projectTitle,projectURL);

        pjaxLoader.classList.remove('visible');
        pjaxMask.classList.add('hide');

        initProject();
      }, 350);
    }
  };
  request.send();
}

document.addEventListener('click', (e) => {
  if(e.target && e.target.matches('.next-link')) {
    e.preventDefault();
    const newURL = e.target.getAttribute('href');
    const newTitle = e.target.textContent;
    const newDirection = 'reverse';
    loadNextProject(newURL, newTitle,newDirection);
    return false;
  }
  if(e.target && e.target.matches('.previous-link')) {
    e.preventDefault();
    const newURL = e.target.getAttribute('href');
    const newTitle = e.target.textContent;
    const newDirection = 'default';
    loadNextProject(newURL, newTitle,newDirection);
    return false;
  }
});


// -----------------------------------------------------------------------------
// Load Article Ajax
// -----------------------------------------------------------------------------
function loadArticle(articleURL,contentType,articleTitle,articleRef) {

  const request = new XMLHttpRequest();
  request.open('GET', articleURL, true);

  // Before Send
  const panel = document.querySelector('.side-panel');
  const backdrop = document.querySelector('.side-panel-backdrop');
  // const paneltitle = document.querySelector('.side-panel-title');
  backdrop.classList.add('visible');
  // paneltitle.innerHTML = contentType;
  panel.classList.add('visible');
  toggleScroll('disable');

  request.onload = function() {
    if (request.status >= 200 && request.status < 400) {
      const projectContainer = document.querySelector('#side-panel-content');
      const resp = request.responseText;
      const parser = new DOMParser();
      const html = parser.parseFromString(resp,"text/html");
      const projectContent = html.querySelector('#article-content');
      projectContainer.appendChild(projectContent);
      projectContainer.classList.add('loaded');
      updateRef(articleRef);
      history.pushState(null,articleTitle,articleURL);
      isPanel = true;
      projectLazyLoad();
    } else {
      // We reached our target server, but it returned an error
      console.log(request.error);
    }
  };
  request.send();
}

// -----------------------------------------------------------------------------
// Project/News Click on tile
// -----------------------------------------------------------------------------

let tileEvent = 'click';
let dragging = false;

if (isTouchDevice()) {
  // console.log('is touch device');
  tileEvent = 'touchend';
  document.body.addEventListener('touchmove', ()=> {
    dragging = true;
  });
}

let thisTitle = '';
let thisType = '';


function getElementTop(el) {

  let yPos = el.offsetTop;
  let yParentPos = el.offsetParent;

  while (yParentPos != null) {
    yPos += yParentPos.offsetTop;
    yParentPos = yParentPos.offsetParent;
  }

  return yPos;
}

/* function rippleEffect() {
  const ev = event;
  const el = event.target;
  const ripple = el.querySelector('.ripple');
  ripple.style.width = ripple.style.height = Math.max(el.offsetWidth, el.offsetHeight) + 'px';
  if (ripple) {
    ripple.classList.remove('animate');
  }

  const clickOffsetX = ev.changedTouches[0].clientX;
  const clickOffsetY = ev.changedTouches[0].clientY;
  const yScroll = window.scrollY;
  const elOffsetY = getElementTop(el);
  const elOffsetX = el.clientLeft;
  const elPosY = elOffsetY - yScroll;
  const rippleLeft = (clickOffsetX - elOffsetX) - ripple.offsetWidth / 2;
  const rippleTop = (clickOffsetY - elPosY) - ripple.offsetHeight / 2;

  ripple.style.left = `${rippleLeft}px`;
  ripple.style.top = `${rippleTop}px`;
  ripple.classList.add('animate');
}
 */
function clickableTile() {
  if (!dragging) {
    if (event.target.classList.contains('project')) {
      const projectURL = event.target.querySelector('a').getAttribute('href');
      const thisBtn = event.target;
      thisTitle = event.target.getAttribute('data-title');
      const thisRef = event.target.getAttribute('data-ref');
      event.target.classList.add('loading');
      loadProject(projectURL,thisBtn,thisTitle,thisRef);
    } else if (event.target.classList.contains('news')) {
      const articleURL = event.target.querySelector('a').getAttribute('href');
      thisType = event.target.getAttribute('data-type');
      thisTitle = event.target.getAttribute('data-title');
      const thisRef = event.target.getAttribute('data-ref');
      loadArticle(articleURL,thisType,thisTitle,thisRef);
    }
    event.stopPropagation();
  }
}

function setClickableTile() {
  const tiles = document.querySelectorAll('.clickable');
  // tiles.forEach(tile => tile.removeEventListener(tileEvent, clickableTile));
  tiles.forEach(tile => tile.addEventListener(tileEvent, clickableTile));
}

document.body.addEventListener('touchstart', ()=> {
  dragging = false;
});

// -----------------------------------------------------------------------------
// Close Side Panel
// -----------------------------------------------------------------------------
function closePanel() {
  // e.preventDefault();
  const sidePanel = document.querySelector('.side-panel');
  const sidePanelContent = document.querySelector('#side-panel-content');
  const backDrop = document.querySelector('.side-panel-backdrop');
  const pagewrapper = document.querySelector('#page-wrapper');

  sidePanel.classList.add('hidding');
  history.replaceState(null,null, refURL);

  setTimeout( ()=> {
    sidePanel.classList.remove('visible');
    backDrop.classList.remove('visible');
    pagewrapper.classList.remove('disabled');
    toggleScroll('enable');
    
  }, 300);


  setTimeout( () => {
    sidePanel.classList.remove('hidding');
    sidePanelContent.classList.remove('loaded');
    sidePanelContent.innerHTML = '';
  }, 600);

  isPanel = false;
  return false;
}
document.addEventListener('click', (e) => {
  if(e.target && e.target.matches('.close-side-panel')) {
    closePanel(e);
  }
});

// -----------------------------------------------------------------------------
// PopState
// -----------------------------------------------------------------------------

window.addEventListener('popstate', function(event) {
  const newURL = location.href;
  let newPath = location.pathname;
  newPath = newPath.split('/');
  newPath = newPath[1];

  const thisParent = '';

  if(newURL.match(/blacheyong\.local/i) || newURL.match(/blacheyong\.com/i)) {
    if (isPanel === true) {
      closePanel();
    } else {
      if (newPath === 'projets' || newPath === 'projects') {
        loadProject(newURL,thisTitle,refURL);
      } else if (newPath === 'article') {
        loadArticle(newURL,thisType,thisTitle,refURL);
      } else {
        loadPageVanilla(newURL,thisParent,false);
      }
    }
  }

});


// -----------------------------------------------------------------------------
// Pjax - Load Page Content
// -----------------------------------------------------------------------------
function loadPageVanilla(newURL, bool) {
  const wWidth = window.innerWidth;

  const request = new XMLHttpRequest();
  request.open('GET', newURL, true);


  const menuItems = document.querySelectorAll('.menu-item');
  const curItem = document.querySelector(`.menu a[href="${newURL}"]`);
  const langLink = document.querySelector('.menu-item-language:not(.menu-item-language-current) a');
  pjaxMask.classList.remove('visible','hide','reverse');
  pjaxMask.classList.add('show');


  setTimeout( () => {
    pjaxLoader.style.visibility = 'visible';
    pjaxLoader.classList.add('visible');
    pjaxContainer.classList.remove('loaded');
    pjaxContainer.classList.add('hidden');

    menuItems.forEach(item => {
      item.classList.remove('current-menu-item');
    });

    document.querySelector('.site-header').classList.remove('menu-opened');
    // document.querySelector('.menu-toggle').classList.remove('menu-opened');
    document.querySelector('.main-nav-backdrop').classList.remove('menu-opened');

    const curItemParent = curItem.parentNode;
    if (curItemParent) {
      curItemParent.classList.add('current-menu-item');
    }
  }, 350);

  


  request.onload = function() {
    if (request.status >= 200 && request.status < 400) {
      // alert('Request Success!');
      const resp = request.responseText;
      const parser = new DOMParser();
      const html = parser.parseFromString(resp,"text/html");
      const newHeader = html.querySelector('.site-header ');
      const newHeaderClasses = newHeader.getAttribute('class');
      // const newLogo = html.querySelector('.header-logo');
      // const newLogoClasses = newLogo.getAttribute('class');
      // const newToggle = html.querySelector('.menu-toggle');
      // const newToggleClass = newToggle.getAttribute('class');

      const newContent = html.querySelector('#pjax-container').innerHTML;
      const newTitle = html.title;
      const langSwitch = html.querySelector('.menu-item-language:not(.menu-item-language-current) a').getAttribute('href');
      pjaxContainer.innerHTML = '';

      document.querySelector('.site-header').classList.remove('menu-opened');
      // document.querySelector('.menu-toggle').classList.remove('menu-opened');
      // document.querySelector('.header-logo').classList.remove('menu-opened');
      document.querySelector('.main-nav-backdrop').classList.remove('menu-opened');
      document.querySelector('.main-nav-wrapper').style.height = '0px';

      pjaxMask.classList.add('visible');
      pjaxMask.classList.remove('show');

      setTimeout(function() {
        pjaxContainer.innerHTML = newContent;

        pjaxLoader.classList.remove('visible');
        pjaxMask.classList.add('hide');
        pjaxContainer.classList.remove('hidden');
        langLink.setAttribute('href', langSwitch);

        document.querySelector('.site-header').setAttribute('class', newHeaderClasses);
        // document.querySelector('.menu-toggle').setAttribute('class', newToggleClass);

        if (newURL != window.location && bool) {
          window.history.pushState({path: newURL},newTitle,newURL);
          document.title = newTitle;
        }

        toggleScroll('enable');
        if (!location.hash) {
          window.scrollTo(0,0);
        }
        pageInit();
        pjaxContainer.classList.add('loaded');
        trackPageView(newURL);
      }, 350);

    } else {
      // We reached our target server, but it returned an error
      console.log(request.error);
    }
  };
  request.send();
  return false;
}

function hidePjaxMask() {
  setTimeout(()=>{
    pjaxLoader.classList.remove('visible');
    pjaxMask.classList.add('hide');
    pjaxContainer.classList.add('loaded');
  }, 1500);

}

const menuLinks = document.querySelectorAll('.menu-item:not(.menu-item-language) a');
menuLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    const newURL = e.target.getAttribute('href');
    loadPageVanilla(newURL, true);
    return false;
  });
});

document.addEventListener('click', (e) => {
  if(e.target && e.target.matches('.pjax')) {
    e.preventDefault();
    const newURL = e.target.getAttribute('href');
    loadPageVanilla(newURL, true);
    return false;
  }
});

// -----------------------------------------------------------------------------
// Page Init functions
// -----------------------------------------------------------------------------
function pageInit() {
  // logoScroll();
  animatedIcons();
  revealArticle();
  infiniteArticles();
  setClickableTile();
  videoLazyLoad();
  pageLazyLoad.update();
  animateProjectContent();
  // devicesCarousel();
  inviewVideos();
  matchHeight();
  safeMailto();
  collapsibles();
  hidePjaxMask();
  headerVideo();
  teamMembers();
  animateContent();
  animateServices();
  inviewFooter();
}
pageInit();
//document.addEventListener('DOMContentLoaded', pageInit);
window.addEventListener('load', matchHeight);
window.addEventListener('scroll', throttle(stickyNav, 100));
